<template>
  <BasePageContainer
    class="pt-10">
    <PageHeader
      has-back
      with-members>
      進路希望
    </PageHeader>
    <SectionTitle class="mb-3">
      進路希望
    </SectionTitle>
    <PathSurveysForm
      v-if="initialized"
      ref="form"
      :user-id="userId"
      :path-surveys="pathSurveys"
      :api-errors="apiErrors"
      @submit="onSubmit" />
  </BasePageContainer>
</template>

<script>
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import PathSurveysForm from '@/components/view/profile/path_surveys/PathSurveysForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
import SectionTitle from '@/components/view/profile/SectionTitle.vue'

export default {
  components: {
    BasePageContainer,
    PageHeader,
    PathSurveysForm,
    SectionTitle,
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      pathSurveys: null,
      initialized: false,
      apiErrors: null,
    }
  },
  computed: {
    userId() {
      return this.$route.params.id
    },
  },
  created() {
    this.fetchPathSurveys().then(res => {
      this.pathSurveys = res.data.results?.[0] || null
    }).finally(() => {
      this.initialized = true
    })
  },
  methods: {
    onSubmit(values) {
      this.$store.commit('startLoading')
      this.postPathSurveys(values).then(() => {
        this.$store.commit('notify/set', {message: '進路希望を更新しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.$route.params.id}/profile`, { replace: true })
        })
      }).catch(err => {
        this.apiErrors = err.response.data
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    postPathSurveys(values) {
      return this.$axios.post('/profiles/path-surveys/', values)
    },
    fetchPathSurveys() {
      return this.$axios.get('/profiles/path-surveys/', {
        params: {
          user_id: this.userId,
          limit: 1,
        },
      })
    }
  }
}
</script>

<style>

</style>